import { useFloating, flip, shift, offset, autoUpdate, useInteractions, useHover, safePolygon, useFocus, useClick, useRole, useDismiss } from '@floating-ui/react';
import { useState, useMemo, isValidElement } from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const useSelectableOverflow = /* @__PURE__ */ __name((hidden) => {
  const [isOpen, setIsOpen] = useState(false);
  const { context, refs, strategy, x, y } = useFloating({
    open: isOpen,
    placement: "bottom-start",
    onOpenChange: setIsOpen,
    middleware: [
      flip(),
      shift(),
      offset({
        mainAxis: 4
      })
    ],
    whileElementsMounted: autoUpdate
  });
  const { getFloatingProps, getReferenceProps } = useInteractions([
    useHover(context, {
      handleClose: safePolygon()
    }),
    useFocus(context, { keyboardOnly: true }),
    useClick(context, {
      event: "mousedown"
    }),
    useRole(context, { role: "menu" }),
    useDismiss(context)
  ]);
  const selected = useMemo(
    () => hidden.some(
      (current) => isValidElement(current) && current.props.selected
    ),
    [hidden]
  );
  return {
    getFloatingProps,
    getReferenceProps,
    isOpen,
    refs,
    selected,
    strategy,
    x,
    y
  };
}, "useSelectableOverflow");

export { useSelectableOverflow };
//# sourceMappingURL=use-selectable-overflow.js.map
